const pushElement = (element, node, ...rest) => {
    if (!element.children) {
        element.children = [];
    }
    element.children.push(node, ...rest);
};
const popElement = (element) => { var _a; return (_a = element.children) === null || _a === void 0 ? void 0 : _a.pop(); };
export const createElement = (type, children, value, props = {}) => {
    const element = {
        type,
        children,
        props,
        value,
        push: (...args) => pushElement(element, ...args),
        pop: () => popElement(element),
    };
    return element;
};
//# sourceMappingURL=stack-element.js.map